module.exports = __webpack_public_path__ + "img/1503584100.00ab7dbf.jpg";